import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { SuggestedPoint } from '../../../../interfaces/edit-route.response';
import { EditedPoint, EditedStatus } from '../../../../interfaces/edit-route.interface';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatBottomSheetAddNewPointOrReplacePointData } from 'src/app/interfaces/mat.interface';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';
import { EditRouteService } from '../../../../services/edit-route.service';
import { AddItemToCustomRouteService } from 'src/chatbot/service/chat-actions/add-item-to-custom-route.service';
import { take, tap } from 'rxjs';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    TranslateModule,
    DurationPipe
  ],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardComponent {
  public point: InputSignal<SuggestedPoint | EditedPoint> = input.required<SuggestedPoint>();
  
  private _editRouteService = inject(EditRouteService);;
  private _matBottomSheetService = inject(MatBottomSheetService);
  private _matBottomSheetData: MatBottomSheetAddNewPointOrReplacePointData = inject(MAT_BOTTOM_SHEET_DATA);
  private _addItemToCustomRouteService = inject(AddItemToCustomRouteService);

  public isImgError: boolean = false;
  
  public handleClick(point: SuggestedPoint | EditedPoint) {
    if (!this._matBottomSheetData) return;

    if (this._matBottomSheetData.fromChatBot){
      console.log("Point: ", point);
      const payload = {
        element_id: point?.id,
        found_name: point?.title,
        type: point?.type,
        hour: this._matBottomSheetData?.startDate,
        day: 1
      }

      this._addItemToCustomRouteService.addItem(payload).subscribe({
        next: (res) => {
          console.log("QWEQWEQWE:", res)
          this._matBottomSheetService.closeAllMatBottomSheets()
        },
        complete: () => this._matBottomSheetService.closeAllMatBottomSheets()
      });
    }
    
    switch (this._matBottomSheetData.status) {
      case EditedStatus.ADDED: {
        this.addPoint(point as SuggestedPoint);
        break;
      }
      case EditedStatus.UPDATED: {
        this.replacePoint(point as SuggestedPoint);
        break;
      }
      default: {
        console.error('Unknown status:', this._matBottomSheetData.status);
      }
    }
  }
  
  public addPoint(point: SuggestedPoint | EditedPoint) {    
    // get the point according to the pointId
    const dayToShowIndex = this._matBottomSheetData.dayToShowIndex;
    if (dayToShowIndex === undefined || dayToShowIndex === null) return;
    
    const orderIndex = this._matBottomSheetData.orderIndex;
    if (orderIndex === undefined || orderIndex === null) return;
    
    this._editRouteService.addPointToEditedCustomRouteData(point as EditedPoint, orderIndex, dayToShowIndex);
    
    this._matBottomSheetService.closeAllMatBottomSheets();
  }
  
  public replacePoint(pointToReplace: SuggestedPoint | EditedPoint) {
    // get the point according to the pointId
    const dayToShowIndex = this._matBottomSheetData.dayToShowIndex;
    if (dayToShowIndex === undefined || dayToShowIndex === null) return;
    
    const orderIndex = this._matBottomSheetData.orderIndex;
    if (orderIndex === undefined || orderIndex === null) return;
    
    const pointToBeReplaced = this._matBottomSheetData.pointToBeReplaced;
    if (!pointToBeReplaced) return;
    
    this._editRouteService.replacePointToEditedCustomRouteData(pointToReplace as EditedPoint, pointToBeReplaced as EditedPoint, dayToShowIndex);
    
    this._matBottomSheetService.closeAllMatBottomSheets();
  }
  
  public handleImgError() {
    this.isImgError = true;
  }
}
